import classnames from 'classnames';
import React, { forwardRef, useContext } from 'react';
import styled, { ThemeContext, ThemeProvider } from 'styled-components';
import { InputLabelPositions } from '../../../enums/input.js';
import '../../../themes/alert.js';
import '../../../themes/button.js';
import '../../../themes/checkbox.js';
import '../../../themes/divider.js';
import '../../../themes/dropdown.js';
import '../../../themes/fieldset.js';
import '../../../themes/input.js';
import '../../../themes/list.js';
import '../../../themes/listbox.js';
import '../../../themes/loader.js';
import '../../../themes/option.js';
import '../../../themes/popout.js';
import '../../../themes/switch.js';
import { lightTheme } from '../../../themes/themes.js';
import '../../../themes/tooltip.js';

const BaseTextfieldWrapper = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { children, labelPosition, ...otherProps } = props;
    return /*#__PURE__*/ React.createElement("div", {
        ...otherProps,
        className: classnames({
            'bf-textfield__wrapper': true,
            [`bf-textfield__wrapper--label-position-${labelPosition}`]: !!labelPosition,
            [`${otherProps?.className}`]: !!otherProps?.className
        }),
        ref: ref
    }, children);
});
const Wrapper = styled(BaseTextfieldWrapper)`
  align-items: ${({ labelPosition })=>labelPosition === InputLabelPositions.Left ? 'center' : 'stretch'};
  box-sizing: border-box;
  display: flex;
  flex-direction: ${({ labelPosition })=>labelPosition === InputLabelPositions.Left ? 'row' : 'column'};
  position: relative;
`;
const TextfieldWrapper = /*#__PURE__*/ forwardRef((props, ref)=>{
    const themeContext = useContext(ThemeContext);
    return /*#__PURE__*/ React.createElement(ThemeProvider, {
        theme: themeContext || lightTheme
    }, /*#__PURE__*/ React.createElement(Wrapper, {
        ...props,
        ref: ref
    }));
});

export { BaseTextfieldWrapper, TextfieldWrapper };
//# sourceMappingURL=textfield-wrapper.js.map
